


import React, { Component } from 'react';

import CurrentDateTime from './CurrentDateTime';

export default class Header extends Component {

  toggleSidebar = () => {
    document.body.classList.toggle("sidebar-icon-only");
  };

  toggleMobileSidebar = () => {
    document.querySelector(".sidebar").classList.toggle("active");
  };

  render() {

    // ✅ SESSION GET HERE (NOT INSIDE JSX)
    const session = JSON.parse(localStorage.getItem("userSession"));
    const expiry = session?.expiry
      ? new Date(session.expiry).toLocaleString()
      : "N/A";

    return (
      <div>
        <nav className="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">

          <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">

            {/* FULL LOGO */}
            {/* <a className="navbar-brand brand-logo me-5" href="#">
              <img src={logo} className="me-2" alt="logo" />
            </a> */}

            {/* MINI LOGO */}
            {/* <a className="navbar-brand brand-logo-mini" href="#">
              <img src={logoMini} alt="logo" />
            </a> */}

          </div>

          <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">

            {/* Sidebar Toggle */}
            <button
              className="navbar-toggler align-self-center"
              type="button"
              onClick={this.toggleSidebar}
            >
              <span className="icon-menu"></span>
            </button>

            <ul className="navbar-nav mr-lg-2">
              <li className="nav-item nav-search d-none d-lg-block">
                <div className="input-group">

                  {/* ✅ EXPIRY SHOW */}
                  <p style={{ color: 'red', marginRight: '15px' }}>
                    Dear User your login access expires on {expiry}
                  </p>

                  <i className="mdi mdi-calendar" />

                  {/* ✅ CURRENT TIME COMPONENT */}
                  <div>
                    <CurrentDateTime />
                  </div>

                </div>
              </li>
            </ul>

            <ul className="navbar-nav navbar-nav-right"></ul>

            {/* Mobile Toggle */}
            <button
              className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
              type="button"
              onClick={this.toggleMobileSidebar}
            >
              <span className="icon-menu"></span>
            </button>

          </div>
        </nav>
      </div>
    );
  }
}